import React from "react";
import { Chip } from "@mui/material";
import {
  typeColors,
  statusColors,
  defaultTypeColors,
  defaultStatusColors,
} from "../../../pages/VersionHistory/styles";

const VersionChip = ({
  label,
  type = "default", // "type", "status", "count", "default"
  variant = "type", // "type", "status", "count", "default"
  size = "small",
}) => {
  let chipStyle = {
    fontWeight: 500,
    fontSize: "11px",
    height: "28px",
    borderRadius: "4px",
  };

  // Determine colors based on variant and type
  if (variant === "type") {
    const colors = typeColors[type] || defaultTypeColors;
    chipStyle = {
      ...chipStyle,
      backgroundColor: colors.bg,
      color: colors.color,
    };
  } else if (variant === "status") {
    const colors = statusColors[type?.toLowerCase()] || defaultStatusColors;
    chipStyle = {
      ...chipStyle,
      backgroundColor: colors.bg,
      color: colors.color,
    };
  } else if (variant === "count") {
    chipStyle = {
      ...chipStyle,
      backgroundColor: "#f3f4f6",
      color: "#374151",
    };
  } else {
    // default
    chipStyle = {
      ...chipStyle,
      backgroundColor: "#f3f4f6",
      color: "#374151",
    };
  }

  return <Chip label={label} size={size} sx={chipStyle} />;
};

export default VersionChip;
